import axios from 'axios';
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';

import store from '.';
import { Subscription } from '../models/subscription';
import config from '../utils/config';

@Module({
  name: 'subscriptionStore',
  dynamic: true,
  namespaced: true,
  store,
})
export default class SubscriptionStore extends VuexModule {
  _subscription: Subscription;

  @Mutation
  select(_subscription: Subscription): void {
    this._subscription = _subscription;
  }

  @Action
  async resendEmail({ subscription, alias }: { subscription: Subscription; alias: string }): Promise<void> {
    return axios.put(`${config.getAPIAddress()}/subscription/resend/${alias || ''}/${subscription._id}`);
  }

  @Action
  async searchBy({ params, alias }: any): Promise<Subscription> {
    const subscriptionJson = (
      await axios.get(`${config.getAPIAddress()}/subscription/searchBy/${alias || ''}`, {
        params,
      })
    ).data;

    return Subscription.fromJson(subscriptionJson);
  }

  get subscription(): Subscription {
    return this._subscription;
  }
}

export const subscriptionStore = getModule<SubscriptionStore>(SubscriptionStore, store);
